import 'css-chunksrc/client/scenes/projectsTransfer/projectsList/project/styles.scss';export default {
  "project": "_project_kf1bl_1",
  "label": "_label_kf1bl_5",
  "selectedProject": "_selectedProject_kf1bl_14",
  "listsList": "_listsList_kf1bl_18",
  "folderIcon": "_folderIcon_kf1bl_22"
};